import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { RequiredLabel } from '../../../common';
import styleable from 'react-styleable';
import defaultStyle from './text-element.style.js';
import { getCurrentValue } from '../text-input';

// the number of rows for the text area.
// Currently this is fixed to be consistent with ETO.
const textAreaRows = 6;

// Build the text for the character countdown label.
const characterCountText = (characterCount) => characterCount + " character" + (Math.abs(characterCount) !== 1 ? "s" : "") + " remaining";

export class TextElement extends Component {

  render() {
    const { maxLength, isRequired, hidden, label, tooltip, id, rows, response, onChange, disabled, errors, showErrors, css, defaultValue, readOnly } = this.props;

    const maxLengthId = id + '-maxLength';

    const hasErrors = errors && errors.length > 0;
    const errorIds = errors && errors.map(error => error.id + ' ');

    const displayResponse = getCurrentValue(response, defaultValue);

    // use 0 if response is null, otherwise use the actual length of the response
    const currentLength = displayResponse ? displayResponse.length : 0;
    const charsRemaining = maxLength - currentLength;
    const countdownClass = currentLength > maxLength
      ? css.countdownInvalid : css.countdownValid;

    if(hidden) return null;

    var textDisplay = readOnly ? (
      <div>
        <p
          id={id+"-content"}
          className={css.readOnlyText}>
          {displayResponse}
        </p>
        <p
          id={id}
          tabIndex={0}
          role={"textbox"}
          className={'hidden-accessibility'}
          aria-label={label}
          aria-required={isRequired}
          aria-invalid={hasErrors && showErrors}
          aria-describedby={id+"-content " + errorIds + ' ' + maxLengthId}
          aria-multiline="true"
          aria-readonly="true">.</p>
      </div>
    ) : (
      <textarea
        id={id}
        maxLength={maxLength}
        rows={rows}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
        value={displayResponse}
        className={css.textarea}
        aria-required={isRequired}
        aria-invalid={hasErrors && showErrors}
        aria-describedby={errorIds + ' ' + maxLengthId}
        readOnly={readOnly}/>
    );

    // The text element has the following parts, from top to bottom:
    // - Question Text
    // - Multiline Text Area
    // - Character countdown text (example:  "19 characters remaining")
    return (
      <div className={css.group}>
        <RequiredLabel
          hasErrors={hasErrors && showErrors}
          htmlFor={id}
          content={label}
          tooltip={tooltip}
          isRequired={isRequired}
          css={{
            requiredLabel: css.label,
            requiredIndicator: css.requiredIndicator}}/>
        <div className={css.inputWrapper}>
          {textDisplay}
          {readOnly ? null:
            <div>
              <span id={maxLengthId} className="skip">{maxLength ? maxLength + ' characters max' : '' }</span>
              <label aria-hidden='true' className={countdownClass}>{characterCountText(charsRemaining)}</label>
            </div>
          }
        </div>
      </div>
    );
  }}

TextElement.defaultProps = {
  rows: textAreaRows
};

TextElement.propTypes = {
  maxLength: PropTypes.number,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  tooltip: PropTypes.string,
  id: PropTypes.any,
  rows: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  response: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  errors: PropTypes.object,
  showErrors: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default styleable(defaultStyle) (TextElement);
